/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect } from 'react'

import { responseError } from '../../../utilitários/handler/responseHandler'

import { api } from '@/api/api'
import { rotasApiAutenticadoV5 } from '@/configurações/rotasApi/rotasApiAutenticadoV5'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { z } from 'zod'

const { path } = rotasApiAutenticadoV5.buscarMatricula
export const useAuthPegarInstituicao = (condicao: Schema) => {
  const queryClient = useQueryClient()
  const { data } = useQuery({
    queryKey: ['instituicao', condicao],
    queryFn: async () => await endPoint(condicao),
    enabled: condicao.matricula !== ' ',
    onError: (error: AxiosError) => {
      const queryState = queryClient.getQueryState(['instituicao', condicao])
      if (queryState?.status === 'error') {
        responseError(error)
      }
    },
  })

  return { data, instituicoes: data?.instituicoes }
}

async function endPoint(
  condicao: Schema,
): Promise<ServiceResponseAuthBuscarMatriculaV5> {
  const result = await api().get(path(condicao.matricula))
  return result.data.data
}

const schema = z.object({
  matricula: z.string().min(1),
})

type Schema = z.infer<typeof schema>

export interface ServiceResponseAuthBuscarMatriculaV5 {
  matricula: string
  instituicoes: Array<{
    id: string
    nome: string
  }>
}
